import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import {
  buildHead,
  SITE_URL,
  ORG_ID,
  ORGANIZATION_SCHEMA,
} from "@/lib/seo-head";

export const Route = createFileRoute("/")({
  head: () =>
    buildHead({
      title: "Interior Design & Fit-Out Contractor in Bahrain | Abacus",
      description:
        "Turnkey interior design, fit-out, joinery, MEP and lighting for retail, F&B and corporate spaces across Bahrain and the GCC. 24+ years, 180+ brands.",
      path: "/",
      schemaJson: [
        ORGANIZATION_SCHEMA,
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "@id": `${SITE_URL}/#website`,
          url: SITE_URL,
          name: "Abacus Design Solutions",
          publisher: { "@id": ORG_ID },
        },
      ],
    }),
  component: Index,
});
